export const defaultAvatarRegex = new RegExp('assets/users/images|missing')

export const isDefaultPlatformAvatar = image => defaultAvatarRegex.test(image)

export const getAvatar = (image, defaultAvatar) => {
  if (!defaultAvatar) return image
  if (!image || isDefaultPlatformAvatar(image)) return defaultAvatar
  return image
}
